"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toGeneralCusto = exports.createComponentsTransformation = exports.transformToCusto = exports.InjectHook = exports.WrapInCustHookChangeError = exports.CustoType = exports.createProviders = exports.CustoMergeFlagEnum = exports.createProviderMergingLogic = exports.CustoComponent = exports.CreateCusto = void 0;

var create_1 = require("./create");

Object.defineProperty(exports, "CreateCusto", {
  enumerable: true,
  get: function get() {
    return create_1.CreateCusto;
  }
});
Object.defineProperty(exports, "transformToCusto", {
  enumerable: true,
  get: function get() {
    return create_1.transformToCusto;
  }
});

var components_1 = require("./classes/components");

Object.defineProperty(exports, "CustoComponent", {
  enumerable: true,
  get: function get() {
    return components_1.CustoComponent;
  }
});

var providers_1 = require("./components/providers");

Object.defineProperty(exports, "createProviderMergingLogic", {
  enumerable: true,
  get: function get() {
    return providers_1.createProviderMergingLogic;
  }
});
Object.defineProperty(exports, "createProviders", {
  enumerable: true,
  get: function get() {
    return providers_1.createProviders;
  }
});

var flags_1 = require("./flags");

Object.defineProperty(exports, "CustoMergeFlagEnum", {
  enumerable: true,
  get: function get() {
    return flags_1.CustoMergeFlagEnum;
  }
});

var interfaces_1 = require("./interfaces");

Object.defineProperty(exports, "CustoType", {
  enumerable: true,
  get: function get() {
    return interfaces_1.CustoType;
  }
});

var wrappers_1 = require("./components/wrappers");

Object.defineProperty(exports, "WrapInCustHookChangeError", {
  enumerable: true,
  get: function get() {
    return wrappers_1.WrapInCustHookChangeError;
  }
});
Object.defineProperty(exports, "InjectHook", {
  enumerable: true,
  get: function get() {
    return wrappers_1.InjectHook;
  }
});

var transformations_1 = require("./classes/helper-fns/transformations");

Object.defineProperty(exports, "createComponentsTransformation", {
  enumerable: true,
  get: function get() {
    return transformations_1.createComponentsTransformation;
  }
});

var prop_generics_1 = require("./utils/prop-generics");

Object.defineProperty(exports, "toGeneralCusto", {
  enumerable: true,
  get: function get() {
    return prop_generics_1.toGeneralCusto;
  }
});